import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

import ListShops from './containers/ListShops';
import CreateShop from './containers/CreateShop';
import EditShop from './containers/EditShop';
import ViewShop from './containers/ViewShop';

const routes = [
    {
        type: 'crud',
        list: ListShops,
        create: CreateShop,
        edit: EditShop,
        view: ViewShop
    }
]

export default ModuleBootstrapper.getRoutes("shops", routes)
